module.exports = __webpack_public_path__ + "assets/arrow_down_white-87c060.svg";